import ProMessage from './message';

export default ProMessage;
